import {
  DailyLegLoadStandaloneEditor
} from '../../models/daily-leg-loads/daily-leg-load.models';
import { Injectable } from '@angular/core';
import { AppConfig } from '../../app/app.config';
import { HttpClient } from '@angular/common/http';
import { DateService } from '../date/date.service';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { TimeZoneService } from '../time-zone/time-zone.service';
import { DateTime } from 'luxon';

@Injectable()
export class DailyLegLoadStandaloneService {

  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
    private dateService: DateService,
    private dateParserService: DateParserService,
    private timeZoneService: TimeZoneService
  ) {
  }

  async saveDailyLegLoadStandaloneEditor(editor: DailyLegLoadStandaloneEditor): Promise<number> {
    editor = this.dateParserService.removeOffsetFromLuxonDates(editor);

    const url = `${this.config.apiUrl}api/dailylegload/standalone/save`;

    return this.http
      .post<number>(url, editor)
      .toPromise()
      .then((res: number) => {
        return res;
      });
  }

  async validateTime(editor: DailyLegLoadStandaloneEditor): Promise<boolean> {
    editor = this.dateParserService.removeOffsetFromLuxonDates(editor);

    const url = `${this.config.apiUrl}api/dailylegload/standalone/validate`;

    return this.http
      .post<boolean>(url, editor)
      .toPromise()
      .then((res: boolean) => {
        return res;
      });
  }

  async deleteDailyLegLoadStandaloneEditor(editor: DailyLegLoadStandaloneEditor): Promise<void> {
    const url = `${this.config.apiUrl}api/dailylegload/standalone/delete`;

    await this.http.post<void>(url, editor).toPromise();
  }

  async getGridData(dailyLogDate: DateTime): Promise<DailyLegLoadStandaloneEditor[]> {
    const dateLong = dailyLogDate.toMillis();
    const url = `${this.config.apiUrl}api/dailylegload/standalone/${dateLong}`;

    let result = await this.http.get<DailyLegLoadStandaloneEditor[]>(url).toPromise();

    result = await this.setStandaloneReadingEditorLocalDates(result);

    return result;
  }

  private async setStandaloneReadingEditorLocalDates(editors: DailyLegLoadStandaloneEditor[]): Promise<DailyLegLoadStandaloneEditor[]> {
    for (let i = 0; i < editors.length; i++) {
      editors[i].readingTime = await this.dateParserService.deserializePtLuxonDate(editors[i].readingTime, this.timeZoneService, editors[i].readingTimeOffset);

      if (editors[i].readingTime) {
        editors[i].readingTimeShow = this.dateService.setFullTimeString(editors[i].readingTime.dateTime);
      }
    }

    return editors;
  }
}



// WEBPACK FOOTER //
// ./src/services/daily-leg-loads/daily-leg-load-standalone.service.ts